export const locale = {
  lang: 'es',
  data: {
    'PORTAL': {
      'BTN_SCREE_SHO':'Tomar captura de pantalla',
      'TOTALCOLA':'Total de colaboradores',
      'TOTALFAL': 'Colaboradores que aún no responden',
      'TOTALCONT':'Colaboradores que ya respondieron',
      'TOTALPRO': 'Progreso total',
      'REPORTE':'Cantidad de respuestas recomendado para...',
      'RANKING':'Cantidad de respuestas mínima para...',
      'TOOLT_REPORTE':'Cantidad de respuestas recomendado para entrega de resultados estadísticamente significativos por corte demográfico.',
      'TOOLT_RANKING':'Cantidad de respuestas mínima para Certificación/Ranking de la empresa.',

      'REPORTE_CER_CARCA':'Cantidad de respuestas recomendado para...',
      'TOOLT_REPORTE_CER_CARCA':'Cantidad de respuestas recomendado para entregar resultados estadísticamente por corte demográfico, tomando en cuenta que cada opción obtenga 5 respuestas',
      'RANKING_CER_CARCA':'Cantidad de respuestas mínima para...',
      'TOOLT_RANKING_CER_CARCA':'Cantidad de respuestas mínimas para Certificación / Ranking de la organización ',

      'REPORTE_MED_CARCA':'Cantidad de respuestas recomendado para...',
      'TOOLT_REPORTE_MED_CARCA':'Cantidad de respuestas recomendado para entregar resultados estadísticamente por corte demográfico, tomando en cuenta que cada opción obtenga 5 respuestas',
      'RANKING_MED_CARCA':'Cantidad de respuestas mínima para...',
      'TOOLT_RANKING_MED_CARCA':'Cantidad de respuestas mínimas para Certificación / Ranking de la organización',

      'TOTALLOG':'Personas que aún no finalizan la encuesta pero ya iniciaron',
      'TOTALMIN':'Minímo de empleados requerido',
      'TOTALGONE':'Personas que decidieron no contestar',
      'SELECTFPLA': 'Filtros',
      'TBARRAPROGRESO':'Avance actual',
      'ACCESODENEGADO': 'Enlace de acceso caducado',
      'ACCESOMSJPRE_1': 'Se ha llegado a la fecha de cierre de la encuesta, este portal estará activo aún por ',
      'ACCESOMSJPRE_2': ' dias',
      'BTNOK': 'OK',
      'DIARESTA':'Días restantes',
      'COLAB':'Colaboradores',
      'NO-INFO':'Información ausente en la base de datos de colaboradores',
      'PORTAL_V1':'Portal de conteos V1',
      'PORTAL_V2':'Portal de conteos V2',
      'DI-TRANSCU':'Días transcurridos',
      'ETI_GRAFI_ZONA_HO': 'La fecha que se muestra en el gráfico se ajusta a la hora local en: ',
      'ETI_FILT_V1&V2': 'Los grupos marcados con ( * ) no muestran información por que contienen el número mínimo de usuarios requerido para mostrar el progreso ',
      'WAR_RESU_ARE_MIN5': 'La cantidad de respuestas minimas para mostrar resultados por área es de 5',
      'FILTROS':{
        '1': 'País',
        '2': 'Localidad',
        '3': 'Área - Departamento',
        '4': 'Grado Académico',
        '5': 'Departamento',
        '6': 'Nivel Geográfico 1',
        '7': 'Nivel Geográfico 2',
        '8': 'Nivel Geográfico 3',
        '9': 'Nivel Geográfico 4',
        '10': 'Nivel Geográfico 5',
        '11': 'Nivel Geográfico 6',
        '12': 'Nivel Geográfico 7',
        '13': 'Nivel Geográfico 8',
        '14': 'Nivel Geográfico 9',
        '15': 'Nivel Geográfico 10',
        '16': 'Nivel Estructural 1',
        '17': 'Nivel Estructural 2',
        '18': 'Nivel Estructural 3',
        '19': 'Nivel Estructural 4',
        '20': 'Nivel Estructural 5',
        '21': 'Nivel Estructural 6',
        '22': 'Nivel Estructural 7',
        '23': 'Nivel Estructural 8',
        '24': 'Nivel Estructural 9',
        '25': 'Nivel Estructural 10',
        '26': 'Área de Negocio',
        '27': 'Nivel Estructural 2',
      },
      'COLUMNAS_TABLA':{
        'NIVEL1': 'Nivel 1',
        'NIVEL2': 'Nivel 2',
        'DEMOGRAFICO': 'Demográfico',
        'SEGMENTO': 'Segmento',
        'COLABORADORES_T': 'Total de colaboradores',
        'PENDIENTES_RESPONDER': 'Colaboradores que aún no responden',
        'YA_RESPONDIERON': 'Colaboradores que ya respondieron',
        'AVANCE': 'Avance',
        'FILTERS': 'Filtros'
      },
      'EXCEL_V2':{
        'TITULO_AVANCE': 'Avance en la aplicación de la encuesta al: ',
        'SHEET': 'Reporte',
        'DESCARGA': 'Portal de conteos de ',
        'MODAL_DESCARGA': 'Descarga correcta'
      },
      'ETIQUETAS':{
        'ETIQUETAS': 'Elementos por página',
        'OF': 'de',
        'BOTON':'Reiniciar filtros'
      },
      'FILTROS_V2':{
        'ninguno': 'Ninguno',
        'Company': 'Empresa',
        'country': 'País',
        'location': 'Localidad',
        'area': 'Área',
        'antiquity': 'Antigüedad',
        'generation': 'Generación',
        'charge': 'Cargo',
        'homologado': 'Cargo homologado',
        'gender': 'Género',
        'typeofwork': 'Tipo de trabajo',
        'workCondition': 'Condiciones de trabajo',
        'academico': 'Grado académico',
        'contratacion': 'Tipo de contratación',
        'personal': 'Tipo de personal',
        'geo_1': 'Nivel geográfico 1',
        'geo_uno': 'Nivel geográfico 1',
        'geo_2': 'Nivel geográfico 2',
        'geo_3': 'Nivel geográfico 3',
        'geo_4': 'Nivel geográfico 4',
        'geo_5': 'Nivel geográfico 5',
        'geo_6': 'Nivel Geográfico 6',
        'geo_7': 'Nivel Geográfico 7',
        'geo_8': 'Nivel Geográfico 8',
        'geo_9': 'Nivel Geográfico 9',
        'geo_10': 'Nivel Geográfico 10',
        'structure_1': 'Nivel estructural 1',
        'structure_2': 'Nivel estructural 2',
        'structure_3': 'Nivel estructural 3',
        'structure_4': 'Nivel estructural 4',
        'structure_5': 'Nivel estructural 5',
        'structure_6': 'Nivel estructural 6',
        'structure_7': 'Nivel estructural 7',
        'structure_8': 'Nivel estructural 8',
        'structure_9': 'Nivel estructural 9',
        'structure_10': 'Nivel estructural 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Nivel estructural 1',
        'structure_DOS': 'Nivel estructural 2',
        'structure_TRES': 'Nivel estructural 3',
        'structure_CUATRO': 'Nivel estructural 4',
        'structure_CINCO': 'Nivel estructural 5',
        'structure_SEIS': 'Nivel estructural 6',
        'structure_SIETE': 'Nivel estructural 7',
        'structure_OCHO': 'Nivel estructural 8',
        'structure_NUEVE': 'Nivel estructural 9',
        'structure_DIEZ': 'Nivel estructural 10',
        'bUnit': 'Unidad de negocio',
      },
      'FILTROS_V2_HK':{
        'ninguno': 'Ninguno',
        'Company': 'Empresa',
        'country': 'País',
        'location': 'Localidad',
        'area': 'Departamento',
        'antiquity': 'Antigüedad',
        'generation': 'Generación',
        'charge': 'Cargo o función en la empresa',
        'homologado': 'Cargo homologado',
        'gender': 'Género',
        'typeofwork': 'Tipo de trabajo',
        'workCondition': 'Condiciones de trabajo',
        'academico': 'Grado académico',
        'contratacion': 'Tipo de contratación',
        'personal': 'Tipo de personal',
        'geo_1': 'Nivel geográfico 1',
        'geo_uno': 'Nivel geográfico 1',
        'geo_2': 'Nivel geográfico 2',
        'geo_3': 'Nivel geográfico 3',
        'geo_4': 'Nivel geográfico 4',
        'geo_5': 'Nivel geográfico 5',
        'geo_6': 'Nivel Geográfico 6',
        'geo_7': 'Nivel Geográfico 7',
        'geo_8': 'Nivel Geográfico 8',
        'geo_9': 'Nivel Geográfico 9',
        'geo_10': 'Nivel Geográfico 10',
        'structure_1': 'Nivel estructural 1',
        'structure_2': 'Nivel estructural 2',
        'structure_3': 'Nivel estructural 3',
        'structure_4': 'Nivel estructural 4',
        'structure_5': 'Nivel estructural 5',
        'structure_6': 'Nivel estructural 6',
        'structure_7': 'Nivel estructural 7',
        'structure_8': 'Nivel estructural 8',
        'structure_9': 'Nivel estructural 9',
        'structure_10': 'Nivel estructural 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Nivel estructural 1',
        'structure_DOS': 'Nivel estructural 2',
        'structure_TRES': 'Nivel estructural 3',
        'structure_CUATRO': 'Nivel estructural 4',
        'structure_CINCO': 'Nivel estructural 5',
        'structure_SEIS': 'Nivel estructural 6',
        'structure_SIETE': 'Nivel estructural 7',
        'structure_OCHO': 'Nivel estructural 8',
        'structure_NUEVE': 'Nivel estructural 9',
        'structure_DIEZ': 'Nivel estructural 10',
        'bUnit': 'Unidad de negocio',
      },
      'PRODUCTO':{
        'CERT':'Certificar',
        'MED':'Medir',
        'NOM35':'Norma 035',
        'PULSE':'Pulsecheck',
        'FOCUS':'Focus Area',
        'MEDIR_1': 'Medir ',
        'MEDIR_2': 'Measurement + MST',
        'MEDIR_3': 'Measurement by areas',
        'MEDIR_4': 'Measurement by leaders',
        'MEDIR_5': 'Measurement by dimensions',
        'MEDIR_6': 'Measurement to certify',
        'NAME':'Empresa: ',
        'PRODUCTO':'Producto: ',
        'PORTAL':'Portal de conteos ',
        'LEADER_GO':'Leader Go',
        'AMCO':'AMCO',
        'TRAB_DIGN':'Trabajo digno',
        'PRI_EMPLE':'Primer empleo',
        'CGO_EXPRE':'CGO EXPRESS',
      },
      'EXCEL':{
        'NOMBOTON': 'Exportar excel',
        'NOMBOTONREDUCIDO': 'Exportar a excel reducido',
        'NOMEMPRE':'NOMBRE EMPRESA:',
        'NOMUSUARIO':'NOMBRE USUARIO:',
        'NOMPROD':'NOMBRE PRODUCTO:',
        'FECHLANZA':'FECHA LANZAMIENTO:',
        'FECHDESCA':'FECHA DE DESCARGA:',
        'DRESTAN':'DIA RESTANTES:',
        'TOTALCOLA':'TOTAL DE COLABORADORES:',
        'TOTALFAL': 'COLABORADORES QUE AUN NO RESPONDEN:',
        'TOTALCONT':'COLABORADORES QUE YA RESPONDIERON:',
        'TOTALPRO': 'PROGRESO TOTAL:',
        'TOTALGONE':'Personas que decidieron no contestar',
        'REPORTE':'INDICE DE RESPUESTA PARA ENTREGABLES:',
        'RANKING':'MUESTRA PARA CERTIFICACION Y RANKING:',
        'FILT':'FILTRO:',
        'NOMFILT':'NOMBRE FILTRO:',
        //pestaña principal
        'INFOGENE': 'Informe general',
        'FILTROSNAME':{
          'country':'país',
          'location':'ubicación',
          'area':'área',
          'antiquity':'antigüedad',
          'generation':'generación',
          'charge':'carga',
          'homologado':'homologado',
          'gender':'género',
          'typeofwork':'tipo de trabajo',
          'workCondition':'Condición de trabajo',
          'academico':'académico',
          'contratacion':'Contratación',
          'personal':'personal',
          'geo_1':'geo_1',
          'geo_2':'geo_2',
          'geo_3':'geo_3',
          'geo_4':'geo_4',
          'geo_5':'geo_5',
          'structure_1':'estructura_1',
          'structure_2':'estructura_2',
          'structure_3':'estructura_3',
          'structure_4':'estructura_4',
          'structure_5':'estructura_5',
          'structure_6':'estructura_6',
          'structure_7':'estructura_7',
          'structure_8':'estructura_8',
          'structure_9':'estructura_9',
          'structure_10':'estructura_10',
        }

      },
      'TIPO-PERSONAL':{
        'TIPO':'Tipo Personal',
        '1':'Sindicalizado',
        '2':'Confianza',
        '3':'Ambos',
      }

    },
    'PORTAL35': {
      'TOTALCOLA':'Total de colaboradores',
      'TOTALFAL': 'Colaboradores que aún no responden',
      'TOTALCONT':'Colaboradores que ya respondieron',
      'TOTALPRO': 'Muestra',
      'TOTALGONE':'Personas que decidieron no contestar',
      'SELECTFPLA': 'Centros de trabajo',
      'TBARRAPROGRESO':'Avance actual',
      'TOTALLOG':'Personas que aún no finalizan la encuesta pero ya iniciaron',
      'FILTROS':{
        '1': 'Centro de trabajo',
        '2': 'País',
        '3': 'Localidad',
        '4': 'Área',
        '5': 'Grado Académico',
        '6': 'Departamento',
        '7': 'Nivel Geográfico 1',
        '8': 'Nivel Geográfico 2',
        '9': 'Nivel Geográfico 3',
        '10': 'Nivel Geográfico 4',
        '11': 'Nivel Estructural 1',
        '12': 'Nivel Estructural 2',
        '13': 'Nivel Estructural 3',
        '14': 'Nivel Geográfico 8',
        '15': 'Nivel Geográfico 9',
        '16': 'Nivel Geográfico 10',
        '17': 'Nivel Jerárquico 1',
        '18': 'Nivel Jerárquico 2',
        '19': 'Nivel Jerárquico 3',
        '20': 'Nivel Jerárquico 4',
        '21': 'Nivel Jerárquico 5',
        '22': 'Nivel Jerárquico 6',
        '23': 'Nivel Jerárquico 7',
        '24': 'Nivel Jerárquico 8',
        '25': 'Nivel Jerárquico 9',
        '26': 'Nivel Jerárquico 10',
      }

    },
    'BTN':{
      'USERS':'Colaboradores'
    }
  }
};
